import { render, staticRenderFns } from "./reAdviceModal.vue?vue&type=template&id=f9032966&scoped=true&"
import script from "./reAdviceModal.vue?vue&type=script&lang=js&"
export * from "./reAdviceModal.vue?vue&type=script&lang=js&"
import style0 from "./reAdviceModal.vue?vue&type=style&index=0&id=f9032966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9032966",
  null
  
)

export default component.exports